export default {
  searching: 'Søger',
}
